import type {TriggerIntegration} from '@cohort/merchants/apps';
import TypeformFillFormTriggerIntegrationConfigComponent from '@cohort/merchants/apps/typeform/triggerIntegrations/fillForm/ConfigComponent';
import TypeformFillFormTriggerIntegrationStepCompletionContextComponent from '@cohort/merchants/apps/typeform/triggerIntegrations/fillForm/StepCompletionContextComponent';
import TypeformFillFormTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/typeform/triggerIntegrations/fillForm/StepCompletionTitleComponent';
import TypeformFillFormTriggerIntegrationComponentPreview from '@cohort/merchants/apps/typeform/triggerIntegrations/fillForm/TriggerComponentPreview';
import useTypeformStepCompletionColumns from '@cohort/merchants/apps/typeform/triggerIntegrations/useTypeformStepCompletionColumns';
import type {TypeformFillFormTriggerStruct} from '@cohort/shared/apps/typeform/triggers/fillForm';
import {TypeformFillFormTriggerIntegrationSpec} from '@cohort/shared/apps/typeform/triggers/fillForm';

export const TypeformFillFormTriggerIntegration: TriggerIntegration<TypeformFillFormTriggerStruct> =
  {
    spec: TypeformFillFormTriggerIntegrationSpec,
    configComponent: TypeformFillFormTriggerIntegrationConfigComponent,
    stepCompletionTitleComponent: TypeformFillFormTriggerIntegrationStepCompletionTitleComponent,
    stepCompletionContextComponent:
      TypeformFillFormTriggerIntegrationStepCompletionContextComponent,
    useStepCompletionColumns: context =>
      useTypeformStepCompletionColumns<TypeformFillFormTriggerStruct>({
        ...context,
        formIdConfigKey: 'formId',
        questionsWithAnswersKey: 'questionsWithAnswers',
      }),
    getTitle: t => t('triggerIntegrations.fill-form.title', {ns: 'app-typeform'}),
    preview: {
      TriggerComponent: TypeformFillFormTriggerIntegrationComponentPreview,
    },
  };
